import type { ApolloCache, Reference } from '@apollo/client'
import { ShiftsRestDayFragment, ShiftsRestDayFragmentDoc } from 'generated/resources/graphql'
import groupBy from 'lodash/groupBy'

import {
  appendRefsToEntityField,
  type ViewRange,
} from 'modules/shift_management/utils/apolloCache/appendRefsToEntityField'

const writeRestDayRefs = (cache: ApolloCache<unknown>, restDays: ShiftsRestDayFragment[]) => {
  const refsById = new Map<string, Reference>()

  restDays.forEach((restDay) => {
    const newRef = cache.writeFragment({
      data: restDay,
      fragment: ShiftsRestDayFragmentDoc,
      fragmentName: 'ShiftsRestDay',
    })

    if (newRef) refsById.set(restDay.id, newRef)
  })

  return refsById
}

const updateCreatedRestDaysCache = ({
  cache,
  view,
  restDays,
}: {
  cache: ApolloCache<unknown>
  view: ViewRange
  restDays: ShiftsRestDayFragment[]
}) => {
  cache.batch({
    update: (batchedCache) => {
      const refsById = writeRestDayRefs(batchedCache, restDays)
      const restDaysByEmployee = groupBy(restDays, (restDay) => restDay.employee?.id)

      Object.entries(restDaysByEmployee).forEach(([employeeId, employeeRestDays]) => {
        if (!employeeId) return

        appendRefsToEntityField({
          cache: batchedCache,
          entity: { __typename: 'ShiftManagementEmployeesPermission', id: employeeId },
          fieldName: 'restDays',
          items: employeeRestDays,
          refsById,
          view,
        })
      })
    },
  })
}

export { updateCreatedRestDaysCache }
